export enum stickyBottomBarVariantsMap {
  "option-1" = "basic",
  "option-2" = "ahPlus",
  "option-3" = "ahpBuyComplete",
  "option-4" = "ahpBuyEssential",
}
